import { toMuteList } from '@/lib/link'
import { SecondaryPageLink } from '@/PageManager'
import { HugeiconsIcon } from '@hugeicons/react'
import { Loading03Icon } from '@hugeicons/core-free-icons'
import client from '@/services/client.service'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export default function MutedCount({ pubkey }: { pubkey: string }) {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(true)
  const [count, setCount] = useState(0)

  useEffect(() => {
    setLoading(true)
    client
      .fetchMuteList(pubkey)
      .then(({ list }) => {
        setCount(list.public.length)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [pubkey])

  return (
    <SecondaryPageLink
      to={toMuteList(pubkey)}
      className="flex gap-1 hover:underline w-fit text-xs items-center"
    >
      {loading ? <HugeiconsIcon icon={Loading03Icon} className="animate-spin size-3" /> : count}
      <div className="text-muted-foreground">{t('Muted')}</div>
    </SecondaryPageLink>
  )
}
